import './fonts.scss';
import './ionic.scss';
import './global.scss';


import Raven from 'raven-js';
import ravenAngular from 'raven-js/plugins/angular';
import Components from './components/components';
import AppComponent from './app.component';
import Config from './app.config';
import Directives from './shared/directives/directives';
import Services from './shared/services/services';
import Filters from './app.filters';
import satellizer from 'satellizer';
import lodash from 'lodash';
import Pusher from 'pusher-js';
// import Echo from 'laravel-echo';

Raven
	.config('https://0fe9309a024e47e5b5214b0ea12e8351@sentry.io/157731')
	.addPlugin(ravenAngular, angular)
	.install();

angular
	.module('app', [
		'ionic',
		'ionic.native',
		'ionic.cloud',
		Components,
		Directives,
		Config,
		Filters,
		Services,
		satellizer,
	])
	.run(function(
		$ionicPlatform,
		$rootScope,
		$filter,
		growl,
		config,
		$state,
		$auth,
		Push
	) {
		"ngInject";

		$ionicPlatform.ready(function() {
			if(window.cordova && window.cordova.plugins.Keyboard) {
				cordova.plugins.Keyboard.hideKeyboardAccessoryBar(true);
				cordova.plugins.Keyboard.disableScroll(true);
			}
			// if ($auth.isAuthenticated() && window.cordova) {
			// 	Push.init();
			// }
			window.addEventListener("online", function(e) {
				growl.info($filter('translate')('growl_connection_online'));
			}, false);

			window.addEventListener("offline", function(e) {
				growl.info($filter('translate')('growl_connection_offline'));
			}, false);
		});

		$rootScope.api = config.api;
		$rootScope.s3 = config.s3;
		$rootScope.$state = $state;

		$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
			console.log(error);
		});

	})
	.config(function($ionicConfigProvider, $compileProvider, $httpProvider, $ionicCloudProvider) {
		"ngInject"

		$ionicCloudProvider.init({
			"core": {
				"app_id": "8da44f35"
			}
		});

		var currentPlatform = ionic.Platform.platform();

		if (currentPlatform === 'macintel') {
			$ionicConfigProvider.scrolling.jsScrolling(false); //disables javascript scrolling
		}

		$ionicConfigProvider.views.transition('none');

		$httpProvider.useApplyAsync(true);
		$compileProvider.debugInfoEnabled(false);
		//$compileProvider.commentDirectivesEnabled(false);
		//$compileProvider.cssClassDirectivesEnabled(false);
	})
	.component('app', AppComponent)


// WEBPACK FOOTER //
// ./app/app.js